import { req, Request } from '../Repository';
import { setFullToken, checkTokenHeaders } from '../apiHelper'

const resource = '/xdent/appointments';

export default {
    getAppointmentsById: (clientId, token) => {
        return req(token).then(token => {
            return Request.get(`${resource}/${clientId}`, token);
        })
    },
    getAllAppointments: token => {
        return req(token).then(token => {
            return Request.get(`${resource}/getallappointmentsbyuser`, token);
        })
    }
}